import { Component, OnInit, inject } from '@angular/core';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { environment } from 'src/environments/environment';
import { ThemeModule, DxcFooterModule } from '@dxc-technology/halstack-angular';
@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    imports: [
        ThemeModule,
        DxcFooterModule,
        TranslateModule,
    ]
})
export class FooterComponent implements OnInit {
  private translate = inject(TranslateService);

  RESOURCE_SERVER_URL = environment.RESOURCE_SERVER_URL;

  footerBottomLinks = [] as any;
  footerSocialLinks = [] as any;
  dxc: string | undefined;
  policy: string | undefined;
  terms: string | undefined;
  ngOnInit(): void {
    this.initFooterData();
  }
  async initFooterData() {
    this.footerSocialLinks = [
      {
        href: 'https://www.facebook.com/DXCTechnology/',
        logoSrc: this.RESOURCE_SERVER_URL + '/assets/images/footer/facebook.svg',
      },
      {
        href: 'https://twitter.com/dxctechnology',
        logoSrc: this.RESOURCE_SERVER_URL + '/assets/images/footer/twitter.svg',
      },
      {
        href: 'https://www.linkedin.com/company/dxctechnology',
        logoSrc: this.RESOURCE_SERVER_URL +'/assets/images/footer/linkedin.svg',
      },
    ];
    this.translate.get('footer.dxc').subscribe((r) => {
      this.dxc = r;
    });
    this.translate.get('footer.policy').subscribe((r) => {
      this.policy = r;
    });
    this.translate.get('footer.terms').subscribe((r) => {
      this.terms = r;
    });
    this.footerBottomLinks = [
      {
        href: '',
        text: this.dxc,
      },
      {
        href: '',
        text: this.policy,
      },
      {
        href: '',
        text: this.terms,
      },
    ];
  }
}
